import { X } from 'lucide-react';
import { BaxterMark } from './BaxterMark';
import { Button } from '@/components/ui/button';

/**
 * Baxter edited what you have open AND you have unsaved changes. Non-blocking on
 * purpose: your edits stay exactly where they are, and Reload is the only thing
 * that throws them away.
 */
export function BaxterChangedBar({
  noun,
  onReload,
  onDismiss,
}: {
  /** "page", "post", "file", "site" — what Baxter changed. */
  noun: string;
  onReload: () => void;
  onDismiss: () => void;
}) {
  return (
    <div
      role="status"
      data-testid="baxter-changed-bar"
      className="mb-4 flex flex-wrap items-center gap-2 rounded-md border border-primary/40 bg-primary/5 px-3 py-2 text-sm"
    >
      <BaxterMark className="size-5" />
      <span className="flex-1">
        Baxter changed this {noun} — your unsaved edits are still here.
      </span>
      <Button size="sm" variant="secondary" onClick={onReload}>
        Reload
      </Button>
      <Button size="icon-sm" variant="ghost" aria-label="Dismiss" onClick={onDismiss}>
        <X />
      </Button>
    </div>
  );
}
